import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "app/store";

interface RefundReceiptModalState {
  open: boolean;
  refundId: number | null;
  patientId: number | null;
}

const initialState: RefundReceiptModalState = {
  open: false,
  refundId: null,
  patientId: null
};

// One modal, two triggers (refunds-table row action + post-refund snackbar). Both
// dispatch `openRefundReceiptModal`; a single mounted <RefundReceiptModal> reads
// this slice. See tech-plan D9.
export const refundReceiptModalSlice = createSlice({
  name: "refundReceiptModal",
  initialState,
  reducers: {
    openRefundReceiptModal: (
      state,
      action: PayloadAction<{ refundId: number; patientId: number | null }>
    ) => {
      state.open = true;
      state.refundId = action.payload.refundId;
      state.patientId = action.payload.patientId;
    },
    closeRefundReceiptModal: (state) => {
      state.open = false;
      state.refundId = null;
      state.patientId = null;
    }
  }
});

export const { openRefundReceiptModal, closeRefundReceiptModal } =
  refundReceiptModalSlice.actions;

export const selectRefundReceiptModal = (state: RootState) =>
  state.refundReceiptModal;

export default refundReceiptModalSlice.reducer;
